import React, {useEffect} from "react";
import {observer} from "mobx-react";
import dashboardSettingsStore from "../../../stores/dashboard-settings-store";
import AppHeader from "./app-header/app-header";
import AppSidebar from "./app-sidebar/app-sidebar";
import PageUrlCoordinator from "./page-url-broadcaster/page-url-coordinator";
import PageViewTracker from "./page-view-tracker/page-view-tracker";

import './app-layout.scss';

interface IAppLayoutProps {
    children?: React.ReactNode;
}

const AppLayout: React.FC<IAppLayoutProps> = observer(({ children }) => {
    useEffect(() => {
        dashboardSettingsStore.load();
    }, []);

    if (!dashboardSettingsStore.showHeaderAndSidebar) {
        return (
            <>
                <PageViewTracker />
                {children}
            </>
        );
    }

    return (
        <div className="app-layout">
            <PageUrlCoordinator />
            <PageViewTracker />
            <AppHeader />
            <AppSidebar />
            {children}
        </div>
    )
})

export default  AppLayout;
